import MuiDialog from '@mui/material/Dialog';
import MuiDialogActions from '@mui/material/DialogActions';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { type ComponentPropsWithoutRef, type ComponentRef, forwardRef } from 'react';

type DialogProps = ComponentPropsWithoutRef<typeof MuiDialog>;
type DialogRef = ComponentRef<typeof MuiDialog>;

export const Dialog = forwardRef<DialogRef, DialogProps>((props, ref) => {
  return <MuiDialog ref={ref} {...props} />;
});
Dialog.displayName = 'Dialog';

type DialogTitleProps = ComponentPropsWithoutRef<typeof MuiDialogTitle>;
type DialogTitleRef = ComponentRef<typeof MuiDialogTitle>;

export const DialogTitle = forwardRef<DialogTitleRef, DialogTitleProps>((props, ref) => {
  return <MuiDialogTitle ref={ref} {...props} />;
});
DialogTitle.displayName = 'DialogTitle';

type DialogContentProps = ComponentPropsWithoutRef<typeof MuiDialogContent>;
type DialogContentRef = ComponentRef<typeof MuiDialogContent>;

export const DialogContent = forwardRef<DialogContentRef, DialogContentProps>((props, ref) => {
  return <MuiDialogContent ref={ref} {...props} />;
});
DialogContent.displayName = 'DialogContent';

type DialogActionsProps = ComponentPropsWithoutRef<typeof MuiDialogActions>;
type DialogActionsRef = ComponentRef<typeof MuiDialogActions>;

export const DialogActions = forwardRef<DialogActionsRef, DialogActionsProps>((props, ref) => {
  return <MuiDialogActions ref={ref} {...props} />;
});
DialogActions.displayName = 'DialogActions';
